import { DocumentsState } from '../../interfaces/DocumentsState';
import { DocumentsActions, FILTER_DOCUMENTS, RESET_FILTER_DOCUMENTS } from '../../actions/Documents.actions';
import { filterDocuments } from './filterDocuments';
import { resetDocuments } from './resetDocuments';

const documentsPageReducer = (state: DocumentsState, action: DocumentsActions): DocumentsState => {
  switch (action.type) {
    case FILTER_DOCUMENTS:
      return filterDocuments(state);
    case RESET_FILTER_DOCUMENTS:
      return resetDocuments(state);
    default:
      return state;
  }
};

export default documentsPageReducer;
